import * as yup from "yup";
import { setLocale } from "yup";

import { LabelConstants } from "@assets/constants";

// Set locale validations.
setLocale({
  mixed: {
    required: LabelConstants.ERROR_LABELS.REQUIRED_FIELD,
  },
  number: {
    min: ({ min }) => ({
      key: LabelConstants.ERROR_LABELS.GREATER_THAN_N,
      values: { n: min },
    }),
    max: ({ max }) => ({
      key: LabelConstants.ERROR_LABELS.MAX_N_EXCEEDED,
      values: { maxVal: max },
    }),
  },
  string: {
    max: ({ max }) => ({
      key: LabelConstants.ERROR_LABELS.MAX_N_CHAR_EXCEEDED,
      values: { n: max },
    }),
    min: ({ min }) => ({
      key: LabelConstants.ERROR_LABELS.MIN_N_CHARACTERS,
      values: { n: min },
    }),
    email: LabelConstants.ERROR_LABELS.INVALID_EMAIL,
  },
});

export const multipleEmailSchema = yup
  .string()
  .test(
    "multiple_emails",
    LabelConstants.ERROR_LABELS.INVALID_EMAILS,
    (allEmailString) =>
      allEmailString
        ? allEmailString
            .split(";")
            .every((email) =>
              !email ? false : yup.string().email().isValidSync(email.trim())
            )
        : true
  );

/**
 * Helper class to reduce the calls to the backend when doing yup async validations.
 * Because of the yup's nature, all the validation are called with every input change, so backend validations will be called with any unrelated field change as well.
 *
 * **How to use:**
 * - This class should be extended  with the validation function which would change isValid property. The function should preferably be of _(value: any, triggerValidation: Callback)=> void_ type.
 * - The yup schema should test the validity with isInputValid for the needed error to show up.
 * - The extended function should be called when the specific input changes/blurs may affect the validity and should trigger the yup validation.
 */
export class AsyncValidationChecker {
  isValid: boolean;

  constructor() {
    this.isValid = false;
  }

  isInputValid = () => this.isValid;
}
